<ul class="conversation-list">
  <shared-conversation-list-search-bar
    [filters]="currentFilters()"
    [availableConversationTypes]="conversationTypes()"
    (filtersChanged)="onFiltersChanged($event)"
    class="search-bar" />
  @let errors = conversationErrors();
  @if (errors.length > 0) {
    <div class="error-wrapper">
      @for (error of errors; track error.id) {
        <orbit-message
          [message]="error.message ?? error.code | translate"
          [severity]="'error'"
          [addonButtonIcon]="refreshIcon"
          (addonButtonClick)="refreshConversations()"
          (keydown)="onRefreshKeyDown($event)" />
      }
    </div>
  }
  @if (hiddenConversationCount() > 0) {
    <div class="hidden-conversations-message" data-testid="hidden-conversations-message">
      <span class="message-text" data-testid="hidden-conversations-message-text">
        {{ (hiddenConversationCount() === 1
            ? 'SHARED.PAGES.DASHBOARD.HIDDEN_CONVERSATIONS.SINGULAR'
            : 'SHARED.PAGES.DASHBOARD.HIDDEN_CONVERSATIONS.PLURAL')
            | translate: { count: hiddenConversationCount() } }}
      </span>
      <button
        class="clear-filters-button"
        data-testid="btn-clear-filters"
        (click)="clearFilters()"
        (keydown)="onClearFiltersKeyDown($event)">
        {{ 'SHARED.PAGES.DASHBOARD.HIDDEN_CONVERSATIONS.CLEAR_FILTERS' | translate }}
      </button>
    </div>
  }
  <rx-virtual-scroll-viewport
    autosize
    class="menu-user-items"
    #conversationList
    (viewRange)="rangeChanged($event)"
    [runwayItems]="1"
    [runwayItemsOpposite]="1">
    <shared-conversation-header
      *rxVirtualFor="
        let conversation of conversations();
        trackBy: trackByFn;
        renderCallback: viewsRendered$
      "
      [isActive]="isActive(conversation.id)"
      [conversation]="conversation"
      [conversationType]="conversationTypes() | findBy: 'id' : conversation.conversationTypeId"
      data-testid="conversation-list-item"
      [attr.data-conversation-id]="conversation.id"
      (click)="changeActiveState(conversation.id)"
      (keydown)="onChangeActiveStateKeyDown($event, conversation.id)" />
  </rx-virtual-scroll-viewport>
</ul>
